import {actionMap} from '../reducer/index'
import * as types from './types'

export default () => dispatch => {
    dispatch({
        type: types.RESET_ERROR
    })
}

export const handler_RESET_ERROR = (reduxState) => {
    return {
        ...reduxState,
        message: undefined
    }
}

actionMap[types.RESET_ERROR] = handler_RESET_ERROR


// WEBPACK FOOTER //
// ./src/shared/errorHandler/actions/resetError.js